(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cquiz]').forEach(function (quiz) {
    var steps = quiz.querySelectorAll('.cquiz__step');

    function show(selector) {
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      var target = quiz.querySelector(selector);
      if (!target) return;
      target.classList.add('is-active');

      // Keep the question in view when the panel is taller than the viewport,
      // but do not yank the page on the very first render.
      var top = quiz.getBoundingClientRect().top;
      if (top < 0) quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    quiz.addEventListener('click', function (event) {
      var goto = event.target.closest('[data-goto]');
      if (goto) {
        show('[data-step="' + goto.dataset.goto + '"]');
        return;
      }
      var result = event.target.closest('[data-result]');
      if (result) {
        show('[data-result-for="' + result.dataset.result + '"]');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cursos"] && !Shopify.designMode) return;
  try {
    
  // Mejora progresiva: sin JS se ve la tarjeta por defecto, que ya trae una
  // recomendacion util.
  document.querySelectorAll('[data-cur-guide]').forEach(function (guide) {
    var opts = Array.prototype.slice.call(guide.querySelectorAll('[data-cur-opt]'));
    var recs = Array.prototype.slice.call(guide.querySelectorAll('[data-cur-rec]'));
    var fallback = guide.querySelector('[data-cur-default]');

    function show(target) {
      recs.forEach(function (rec) {
        if (rec === target) {
          rec.removeAttribute('hidden');
        } else {
          rec.setAttribute('hidden', '');
        }
      });
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var on = opt.getAttribute('aria-pressed') === 'true';
        opts.forEach(function (other) {
          other.setAttribute('aria-pressed', 'false');
        });
        if (on) {
          show(fallback);
          return;
        }
        opt.setAttribute('aria-pressed', 'true');
        show(document.getElementById(opt.getAttribute('aria-controls')));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayoreo"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement only: every panel is readable and the plan cards
  // carry the full offer if this never runs.
  document.querySelectorAll('.myo').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-myo-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-myo-panel]'));

    function show(index) {
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        show(i);
        var select = root.querySelector('[data-myo-type]');
        if (select) {
          var wanted = tab.textContent.trim();
          Array.prototype.slice.call(select.options).forEach(function (option) {
            if (option.value === wanted) select.value = wanted;
          });
        }
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (next === null) return;
        event.preventDefault();
        show(next);
        tabs[next].focus();
      });
    });

    var calc = root.querySelector('[data-myo-calc]');
    if (!calc) return;

    var range = calc.querySelector('[data-myo-kg]');
    var out = calc.querySelector('[data-myo-kg-out]');
    var priceEl = calc.querySelector('[data-myo-price]');
    var totalEl = calc.querySelector('[data-myo-total]');
    var saveEl = calc.querySelector('[data-myo-save]');
    var nudgeEl = calc.querySelector('[data-myo-nudge]');

    var shopPrice = parseFloat(calc.dataset.shopPrice) || 0;
    var proPrice = parseFloat(calc.dataset.proPrice) || 0;
    var entPrice = parseFloat(calc.dataset.entPrice) || 0;
    var entFrom = parseFloat(calc.dataset.entFrom) || 0;

    function money(value) {
      return '$' + Math.round(value).toLocaleString('es-MX');
    }

    function update() {
      var kg = parseInt(range.value, 10) || 0;
      var unit = kg >= entFrom ? entPrice : proPrice;
      var saved = (shopPrice - unit) * kg;

      if (out) out.textContent = kg;
      if (priceEl) priceEl.textContent = money(unit);
      if (totalEl) totalEl.textContent = money(unit * kg);
      if (saveEl) saveEl.textContent = money(saved);

      if (nudgeEl) {
        if (kg < entFrom) {
          nudgeEl.textContent =
            nudgeEl.dataset.below ||
            'Con ' + (entFrom - kg) + ' kg más al mes pasas al mejor precio por kilo.';
        } else {
          nudgeEl.textContent = 'Estás en el mejor precio: ahorras ' + money(saved) + ' cada mes.';
        }
      }

      var volume = root.querySelector('[data-myo-volume]');
      if (volume) {
        Array.prototype.slice.call(volume.options).forEach(function (option) {
          var bounds = option.value.match(/\d+/g);
          if (!bounds) return;
          var low = parseInt(bounds[0], 10);
          var high = bounds[1] ? parseInt(bounds[1], 10) : Infinity;
          if (kg >= low && kg <= high) volume.value = option.value;
        });
      }
    }

    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
